import { render } from "./Project.vue?vue&type=template&id=16aad212"
import script from "./Project.vue?vue&type=script&lang=ts"
export * from "./Project.vue?vue&type=script&lang=ts"

import "./Project.vue?vue&type=style&index=0&id=16aad212&rel=stylesheet&lang=scss"
script.render = render

export default script